import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input,
} from "@chakra-ui/react";
import React, { useState } from "react";
import categorieService from "../../api/categories/categories";

function TablesCategoryRow(props) {
  const { id, name, createdAt } = props;
  const textColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "#1a202c");
  const colorStatus = useColorModeValue("white", "gray.400");

  const toast = useToast();
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(name);

  // Supprimer la catégorie
  const handleDelete = async () => {
    const isConfirmed = window.confirm(`Êtes-vous sûr de vouloir supprimer la catégorie "${name}" ?`);
    
    if (isConfirmed) {
      try {
        await categorieService.deleteCategorie(id);
        toast({
          title: "Catégorie supprimée",
          description: `La catégorie "${name}" a été supprimée avec succès.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        window.location.reload();
      } catch (error) {
        toast({
          title: "Erreur",
          description: "Une erreur est survenue lors de la suppression.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };  

  // Modifier la catégorie
  const handleEdit = async () => {
    try {
      await categorieService.updateCategorie(id, { name: editedName });
      toast({
        title: "Catégorie mise à jour",
        description: `La catégorie a été mise à jour en "${editedName}".`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setIsEditing(false);
      window.location.reload()
    } catch (error) {
      toast({
        title: "Erreur",
        description: "Impossible de mettre à jour la catégorie.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Tr>
        <Td minWidth={{ sm: "250px" }} pl="0px">
          <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
            <Flex direction="column">
              <Text fontSize="md" color={textColor} fontWeight="bold" minWidth="100%">
                {id}
              </Text>
            </Flex>
          </Flex>
        </Td>

        <Td>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {name}
            </Text>
          </Flex>
        </Td>
        <Td>
          <Flex direction="column">
            <Text fontSize="md" color={textColor} fontWeight="bold">
              {createdAt}
            </Text>
          </Flex>
        </Td>
        <Td>
          <Button p="0px" bg="transparent" variant="no-hover" onClick={() => setIsEditing(true)}>
            <Text fontSize="md" color="gray.400" fontWeight="bold" cursor="pointer">
              Edit
            </Text>
          </Button>
          <Button p="0px" bg="transparent" variant="no-hover" onClick={handleDelete} ml={3}>
            <Text fontSize="md" color="red.400" fontWeight="bold" cursor="pointer">
              Supprimer
            </Text>
          </Button>
        </Td>
      </Tr>

      {/* Modal pour l'édition */}
      <Modal isOpen={isEditing} onClose={() => setIsEditing(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifier la catégorie</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              placeholder="Nom de la catégorie"
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleEdit}>
              Modifier
            </Button>
            <Button variant="ghost" onClick={() => setIsEditing(false)}>
              Annuler
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default TablesCategoryRow;
